import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefHistoryDentalHistoryDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryDentalHistory/GetDetail?` + params, null);

export const GetRefHistoryDentalHistoryList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefHistoryDentalHistory/GetList?` + params, null);

export const CreateRefHistoryDentalHistory = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryDentalHistory/Create`, data);

export const UpdateRefHistoryDentalHistory = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryDentalHistory/Update`, data);

export const DeleteRefHistoryDentalHistory = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefHistoryDentalHistory/Delete`, data);